import { render, staticRenderFns } from "./VehicleBehaviorWidget.vue?vue&type=template&id=45ecf76c&scoped=true&"
import script from "./VehicleBehaviorWidget.vue?vue&type=script&lang=js&"
export * from "./VehicleBehaviorWidget.vue?vue&type=script&lang=js&"
import style0 from "./VehicleBehaviorWidget.vue?vue&type=style&index=0&id=45ecf76c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45ecf76c",
  null
  
)

export default component.exports